import {
  Box,
  Divider,
  Drawer,
  FormControl,
  Icon,
  InputLabel,
  List,
  ListItemButton,
  MenuItem,
  Select,
  styled,
  Typography,
} from '@mui/material'
import React from 'react'
import { Link } from 'react-router-dom-v5-compat'

import IconText from '@/app/component/layout/icon-text'
import { Organization, SelectOption } from '@/app/types'

type Props = {
  open: boolean
  hasOrg: boolean
  activeOrg?: Organization
  organizations?: SelectOption<number>[]
  email: string
  logout: () => void
  onClose: () => void
  onOrgSelect: (org: SelectOption<number>) => void
}

const CATIMobileDrawer: React.FC<Props> = ({
  open,
  hasOrg,
  activeOrg,
  organizations,
  email,
  logout,
  onClose,
  onOrgSelect,
}) => (
  <Box
    sx={{
      display: {
        xs: 'block',
        md: 'none',
      },
    }}
  >
    <Drawer open={open} onClose={onClose}>
      <StyledList>
        <ListItemButton disabled>
          <IconText>
            <Icon>person</Icon>
            <Typography>{email}</Typography>
          </IconText>
        </ListItemButton>
        <Divider sx={{ my: 1 }} />

        {hasOrg && organizations && organizations.length > 1 && (
          <>
            <Box sx={{ px: 2, py: 1 }}>
              <FormControl fullWidth size="small">
                <InputLabel>Organization</InputLabel>
                <Select
                  value={activeOrg?.orgId || ''}
                  label="Organization"
                  onChange={(e) => {
                    const selectedOrg = organizations.find((org) => org.value === e.target.value)
                    if (selectedOrg) {
                      onOrgSelect(selectedOrg)
                    }
                  }}
                >
                  {organizations.map((org) => (
                    <MenuItem key={org.value} value={org.value}>
                      {org.label}
                    </MenuItem>
                  ))}
                </Select>
              </FormControl>
            </Box>
            <Divider sx={{ my: 1 }} />
          </>
        )}
        <List sx={{ p: 0 }}>
          <ListItemButton component={Link} to="/account" data-testid="nav-mobile-profile" onClick={onClose}>
            <IconText>
              <Icon data-testid="nav-mobile-profile-icon">work</Icon>
              <Typography data-testid="nav-mobile-profile-title">Account</Typography>
            </IconText>
          </ListItemButton>
        </List>

        <Divider sx={{ my: 1 }} />

        <List>
          <ListItemButton
            data-testid="nav-mobile-item"
            onClick={() => {
              logout()
              onClose()
            }}
          >
            <IconText>
              <Icon data-testid="nav-mobile-icon">exit_to_app</Icon>
              <Typography data-testid="nav-mobile-title">Log out</Typography>
            </IconText>
          </ListItemButton>
        </List>
      </StyledList>
    </Drawer>
  </Box>
)

const StyledList = styled(List)({
  paddingTop: 64,
  width: 250,
})

export default CATIMobileDrawer
